import React from 'react';
import { area } from 'd3-shape';
import { getScaleY, getScaleX } from '../utils';
var AreaChart = function (_a) {
    var width = _a.width, height = _a.height, chartId = _a.chartId, _b = _a.data, data = _b === void 0 ? [] : _b, scaleX = _a.scaleX, scaleY = _a.scaleY;
    var x = scaleX || getScaleX(width, data);
    var y = scaleY || getScaleY(height, data);
    var chart = area()
        .x(function (d, i) { return x(d[0] ? d[0] : i); })
        .y1(function (d) { return y(d[1]); })
        .y0(y(0))
        .defined(function (d, i) { return d[1] !== undefined; });
    return (React.createElement("svg", { className: "areaChart__svg", id: chartId, width: width, height: height },
        React.createElement("path", { d: chart(data) || undefined })));
};
export default AreaChart;
//# sourceMappingURL=AreaChart.js.map